import { IStudioState } from '~src/store/types';

import { IRealmState } from './types';

export const getCreatingState = (state: IStudioState): IRealmState['isCreating'] => state.realm.isCreating;
